// 返回有值的对象
const formatUrl = (queryInfo) => {
  const formatQueryInfo = {};
  Object.keys(queryInfo).forEach((key) => {
    const queryValue = queryInfo[key];
    if (queryValue) {
      formatQueryInfo[key] = queryInfo[key];
    }
  });
  return formatQueryInfo;
};

export default formatUrl;
